import { fromTimestamp } from '../../helpers/DateHelpers'

export default {
  computed: {
    nullifyEntity () {
      let obj = {}
      for (let prop in this.entity) {
        obj[prop] = this.entity[prop] !== '' && JSON.stringify(this.entity[prop]) !== JSON.stringify({}) ? this.entity[prop] : null
      }
      return obj
    },
    transformedEntity () {
      let obj = { ...this.entity }
      if (!this.transformForUpdate) {
        return obj
      }
      for (let prop in this.transformForUpdate) {
        if (obj[prop] === '' || JSON.stringify(obj[prop]) === JSON.stringify({})) {
          obj[prop] = this.transformForUpdate[prop](obj[prop])
        }
      }
      return obj
    }
  },
  methods: {
    toDate (item) {
      if (item === '' || item === null) {
        return ''
      } else {
        return `${item}T00:00:00.000Z`
      }
    },
    toZero (item) {
      if (item === '' || JSON.stringify(item) === JSON.stringify({})) {
        return 0
      }
      return item
    },
    toMinus (item) {
      if (item === '' || JSON.stringify(item) === JSON.stringify({})) {
        return -1
      }
      return item
    },
    toEmpty (item) {
      if (item === '' || JSON.stringify(item) === JSON.stringify({})) {
        return ''
      }
      return item
    },
    toDateOrNull (item) {
      if (!item) {
        return 'nulldate'
      }
      return item
    },
    toTimestamp (item) {
      if (item === '' || item === null) {
        return ''
      } else {
        let arr = item.split('-')
        return String(new Date(parseInt(arr[0]), parseInt(arr[1]) - 1, parseInt(arr[2]) + 1).getTime() / 1000)
      }
    },
    fromTimestamp
  }
}



// WEBPACK FOOTER //
// ./src/modules/admin/mixins/TransformMixin.js